<template>
   <div class="row v310-pdf">
      <div class="rounded bg-light tc-gray px-0" id='element-to-print'>
         <div class="row rounded-top mx-0" :style="{'background-color':logo_auth_color}">
            <div class="col-6 tx-cl-white align-self-end pb-1 pe-0">
               <b><i>Autorización de medicamentos para patologías crónicas</i></b>
            </div>
            <div class="col-3 align-self-end px-0" >
               <img src="../../../assets/logoauth.png"  style="width:100px">
            </div>
            <div class="col-3 text-center pt-2 tx-cl-white px-0">
               <b>{{pdfData.id}}</b>
               <br>
               <b>{{pdfData.nowDate}}</b>
            </div>
         </div>
         <div class="col-12 px-2 pt-2 fs-15">
            Sr/a. Farmacéutico/a,
         </div>
         <div class="col-12 px-2 fs-15">
           OSPLAD autoriza a expender los siguientes medicamentos para patologías crónicas, según el siguiente detalle:
         </div>
         <div class="row mx-0 mt-1">
            <div class="col-md-1"></div>
            <div class="col-12 col-md-8 p-1 fs-15" pt-2>
               {{beneficiary}} <b class="border rounded px-2">{{pdfData.name}}</b>
            </div>
            <div class="col-12 col-md-3 p-1 fs-15">
               CUIL: <b class="border rounded px-2">{{pdfData.cuil}}</b>
            </div>
            <div class="col-md-1"></div>
            <div class="col-12 col-md-11 p-1 fs-15">
               Fecha de solicitud: <b class="border rounded px-2">{{pdfData.requestDate}}</b>
            </div>
            <div class="col-md-1"></div>
            <div class="col-12 col-md-11 p-1 fs-15">
               Siendo imprescindible que se adjunte la correspondiente receta médica para cada dispensa(*):
            </div>
            <div class="col-md-2"></div>
            <div class="col-12 col-md-10 p-1 fs-15 row ms-0">
               <div v-for="(drug, index) in pdfData.drugs" :key="index" class="border rounded col-10 text-capitalize">
                  <b>{{drug}}</b>
               </div>
            </div>
         </div>
         <div class="col-12 px-2 fs-15 mt-1">
           La presente autorización(**) es válida desde el 
           <b class="border rounded px-2">{{pdfData.prescriptionDate}}</b> hasta el 
           <b class="border rounded px-2">{{pdfData.validDate}}</b> inclusive.
         </div>
         <div class="col-12 px-2 fs-15 mt-2">
           Vencido dicho plazo, {{shehe}} paciente deberá solicitar la renovación de esta autorización, vía e-mail a autorizaciones@osplad.org.ar o en la sede de OSPLAD de su preferencia, adjuntando la Ficha de Empadronamiento de Pacientes Crónicos PMOE actualizada. 
         </div>
         <div class="col-12 px-2 fs-15 mt-2">
           En el caso que la farmacia lo requiera, podrá entregar copía de esta de autorización. 
         </div>
         <div class="col-12 px-2 fs-15 mt-2 mb-3">
           Le recomendamos enviar su solicitud de renovación, dentro de los 15 días anteriores al vencimiento.
         </div>
         <div v-if="pdfData.cancellationReason || pdfData.voucherObservations"
            class="row mx-0 mt-2">
            <div class="col-4 col-md-2">
               Observaciones:
            </div>
            <div class="col-8 col-md-9 p-1 fs-15 row ms-1">
               <div v-if="pdfData.requestCanceled" class="border rounded">
                  <b>La presente autorización {{pdfData.cancellationReason.id == 1 ? 'anula' : 'complementa'}} la número {{pdfData.requestCanceled}}.</b>
               </div>
               <div v-if="pdfData.voucherObservations"
                  class="border rounded fw-bold tc-gray"
                  >
                  <pre class="fs-15 fst-ss mb-0" wrap >{{pdfData.voucherObservations}}</pre>
               </div>
               <!--
               -->
            </div>
         </div>
         <div class="col-12 px-2 fs-15 mt-2">
           Provincia: <b class="border rounded px-2">{{pdfData.provinceState}}</b>
         </div>
         <div class="col-12 px-2 fs-15 mb-2 text-end">
           Operador autorizante: <b class="border rounded px-2">{{pdfData.userName}}</b>
         </div>
         <div class="col-12 px-2 fs-13 mt-2">
           (*)<i>Sí la o las medicaciones prescriptas no se encuentran expresadas en el presente formulario, se debe a que fueron excluidas o reemplazadas de la cobertura del 70%. Ante la duda consulte el VADEMECUM en la página oficial www.osplad.org.ar.</i>
           <br>
           (**)<i>La presente autorización puede variar sin previo aviso en los casos donde, se produzcan modificaciones en la medicación y/o en su porcentaje de cobertura.</i>
         </div>
         <div class="row justify-content-between mx-0 mt-2 border-top fs-12">
            <div class="col-auto"><i>GPM - Código de formulario: A-0009</i></div>            
            <div class="col-auto"><i>{{pdfData.nowDateTime}}</i></div>
         </div>
      </div>
   </div>
</template>

<script>
import { computed } from 'vue';

export default {

   props: {
      pdfData: {
         type: Object,
         required: true
      }
   },
   
   setup( props ) {

      const beneficiary = computed(() => {
            if ( props.pdfData.sex == 'F' ) {
               return 'Beneficiaria: '
            }
            return 'Beneficiario: '
      })

      const shehe = computed(() => {
            if ( props.pdfData.sex == 'F' ) {
               return ' la '
            }
            return ' el '
      })

      return { 
         beneficiary,
         logo_auth_color: process.env.VUE_APP_LOGO_AUTH_COLOR,
         shehe
      }
   }
   
}
</script>

<style>
.tx-cl-white {
   color: white;
}
.tc-gray {
   color: gray;
}
.v310-pdf {
/*   width: 492px;*/
   overflow-x: auto;
}
.fs-12 {
   font-size: 12px;
}
.fs-13 {
   font-size: 13px;
}
.fs-15 {
   font-size: 15px;
}
.fs-16 {
   font-size: 16px;
}
.fst-ss {
   font-family: sans-serif;
}
</style>